import { Chip, styled } from '@mui/material';
import PropTypes from 'prop-types';

const StyledChip = styled(Chip)(({ theme, customcolor }) => ({
  fontWeight: 600,
  fontSize: '0.75rem',
  height: 24,
  borderRadius: 12,
  padding: '0 8px',
  letterSpacing: '0.02em',
  transition: theme.transitions.create(['background-color', 'box-shadow', 'transform'], {
    duration: theme.transitions.duration.shorter
  }),
  '&:hover': {
    transform: 'translateY(-1px)',
    boxShadow: `0 2px 4px ${theme.palette.mode === 'dark'
      ? 'rgba(0, 0, 0, 0.2)'
      : 'rgba(15, 23, 42, 0.1)'}`
  },
  ...(customcolor === 'success' && {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white
  }),
  ...(customcolor === 'error' && {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white
  }),
  ...(customcolor === 'warning' && {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.white
  }),
  ...(customcolor === 'primary' && {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white
  }),
  ...(customcolor === 'info' && {
    backgroundColor: theme.palette.info.main,
    color: theme.palette.common.white
  }),
  ...(customcolor === 'default' && {
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.common.black
  })
}));

export default function StatusBadge({ status, customize, customLabel, customColor, size = 'small' }) {
  const getStatusProps = (status) => {
    switch (status?.toLowerCase()) {
    case 'success':
      return {
        color: 'success',
        label: 'Success'
      };
    case 'failed':
    case 'failure':
      return {
        color: 'error',
        label: 'Failed'
      };
    case 'partially_success':
    case 'partial':
    case 'partial_success':
      return {
        color: 'warning',
        label: 'Partially Successful'
      };
    case 'in_progress':
      return {
        color: 'primary',
        label: 'In Progress'
      };
    case 'in_queue':
      return {
        color: 'info',
        label: 'In Queue'
      };
    case 'pending':
      return {
        color: 'default',
        label: 'Pending'
      };
    case 'no_changes_needed':
      return {
        color: 'info',
        label: 'No Changes Needed'
      };
    case 'active':
      return {
        color: 'success',
        label: 'Active'
      };
    case 'inactive':
      return {
        color: 'default',
        label: 'Inactive'
      };
    case 'create':
      return {
        color: 'success',
        label: 'Create'
      };
    case 'update':
      return {
        color: 'primary',
        label: 'Update'
      };
    case 'delete':
      return {
        color: 'error',
        label: 'Delete'
      };
    default:
      return {
        color: 'default',
        label: status || 'Unknown'
      };
    }
  };

  if(customize && customLabel && customColor) {
    return (
      <StyledChip
        label={customLabel}
        customcolor={customColor}
        size={size}
      />
    );
  }

  const { color, label } = getStatusProps(status);

  return (
    <StyledChip
      label={label}
      customcolor={color}
      size={size}
    />
  );
}

StatusBadge.propTypes = {
  status: PropTypes.string,
  customize: PropTypes.bool,
  customLabel: PropTypes.string,
  customColor: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large'])
};
